
import { NavigationTranslationType } from "../../features/navigation.types";

export const navigation: NavigationTranslationType = {
  navigation: {
    dashboard: "Panel",
    profile: "Perfil",
    signOut: "Cerrar Sesión",
    upgradeRequired: "Actualización Requerida",
    basicSubscriptionRequired: "Suscripción Básica Requerida",
    premiumSubscriptionRequired: "Suscripción Premium Requerida",
  }
};
